export default __webpack_public_path__ + "static/media/united-states.bf988a50.png";